export const tuitionFeeRoutes = [
  {
    path: '/head-fees',
    component: () => import('@/views/tuitionFee/HeadFee.vue'),
    name: 'head-fees',
    meta: {
      title: 'Khoản phí thu/đóng',
      auth: true
    }
  },
  {
    path: '/head-fees/:id',
    component: () => import('@/views/tuitionFee/HeadFeeDetail.vue'),
    name: 'head-fees',
    meta: {
      title: 'Chi tiết khoản phí',
      auth: true
    }
  },
  {
    path: '/arrear-fees',
    component: () => import('@/views/tuitionFee/HeadFee.vue'),
    name: 'arrear-fees',
    meta: {
      title: 'Khoản truy thu',
      auth: true
    }
  },
  {
    path: '/refund-fees',
    component: () => import('@/views/tuitionFee/HeadFee.vue'),
    name: 'refund-fees',
    meta: {
      title: 'Khoản hoàn trả',
      auth: true
    }
  },
  {
    path: '/deduction-head-fees',
    component: () => import('@/views/tuitionFee/HeadFee.vue'),
    name: 'deduction-head-fees',
    meta: {
      title: 'Khoản giảm trừ',
      auth: true
    }
  },
  {
    path: '/deduction-head-fees/:id',
    component: () => import('@/views/tuitionFee/HeadFeeDetail.vue'),
    name: 'deduction-head-fees',
    meta: {
      title: 'Chi tiết khoản giảm trừ',
      auth: true
    }
  },
  {
    path: '/tuition-fee-group',
    component: () => import('@/views/tuitionFee/Group.vue'),
    name: 'TuitionFeeGroup',
    meta: {
      title: 'Nhóm đối tượng chịu phí',
      auth: true
    }
  },
  {
    path: '/tuition-fee-priority-group',
    component: () => import('@/views/tuitionFee/Group.vue'),
    name: 'PriorityGroup',
    meta: {
      title: 'Nhóm đối tượng giảm trừ',
      auth: true
    }
  },
  {
    path: '/tuition-fee-group-detail/:id',
    component: () => import('@/views/tuitionFee/DetailGroup.vue'),
    name: 'TuitionFeeDetailGroup',
    meta: {
      title: 'Chi tiết nhóm đối tượng ',
      auth: true
    }
  },
  {
    path: '/tuition-fee-period',
    component: () => import('@/views/tuitionFee/TuitionFeePeriod'),
    name: 'TuitionFeePeriod',
    meta: {
      title: 'Kỳ thu/đóng',
      auth: true
    }
  },
  {
    path: '/tuition-fee-detail-period/:id',
    component: () => import('@/views/tuitionFee/DetailPeriod.vue'),
    name: 'TuitionFeeDetailPriod',
    meta: {
      title: 'Chi tiết biểu phí trong kỳ theo học sinh',
      auth: true
    }
  },
  {
    path: '/tuition-fee-bank-account',
    component: () => import('@/views/tuitionFee/BankAccount'),
    name: 'BankAccount',
    meta: {
      title: 'Tài khoản ngân hàng',
      auth: true
    }
  },
  {
    path: '/debt-manager',
    component: () => import('@/views/tuitionFee/DebtManager.vue'),
    name: 'DebtManager',
    meta: {
      title: 'Quản lý công nợ',
      auth: true
    }
  },
  {
    path: '/arrear-fees/:id',
    component: () => import('@/views/tuitionFee/HeadFeeDetail.vue'),
    name: 'arrear-fees',
    meta: {
      title: 'Chi tiết khoản truy thu',
      auth: true
    }
  },
  {
    path: '/refund-fees/:id',
    component: () => import('@/views/tuitionFee/HeadFeeDetail.vue'),
    name: 'refund-fees',
    meta: {
      title: 'Chi tiết khoản hoàn trả',
      auth: true
    }
  },
  {
    path: '/financial-report',
    component: () => import('@/views/tuitionFee/FinancialReport.vue'),
    name: 'financial-report',
    meta: {
      title: 'Báo cáo theo kỳ',
      auth: true
    }
  },
  {
    path: '/school-bank-account',
    component: () => import('@/views/school-bank-account/index.vue'),
    name: 'school-bank-account',
    meta: {
      title: 'Tài khoản học phí',
      auth: true
    }
  }
]
